import lodashCloneDeep from "lodash/cloneDeep";

import {
  GET_SEARCH_DETAILS,
  GET_SEARCH_KEYWORD,
  GET_SEARCH_LOCATION,
  GET_SEARCH_LOCATION_REFRESH_MAP,
  GET_SEARCH_ENABLED_ITEMS,
  SAVE_PREFERENCES,
  GET_SELECTOR_PANEL,
  GET_NEWS_REFRESH_MAP,
  GET_SOCIAL_REFRESH_MAP,
  GET_TOPICS_V2_MAP_TOPIC,
  GET_TOPICS_V2_REFRESH_MAP,
  GET_SEARCH_TYPE,
  GET_SEARCH_BOUNDS,
  GET_SEARCH_LOADING,
  GET_CHARTS_DATA,
} from "./actions.type";

import {
  SET_SEARCH_DETAILS,
  SET_SEARCH_KEYWORD,
  SET_SEARCH_LOCATION,
  SET_SEARCH_LOCATION_REFRESH_MAP,
  SET_SEARCH_ENABLED_ITEMS,
  SET_SEARCH_TYPE,
  SET_SEARCH_BOUNDS,
  SET_SEARCH_LOADING,
  SET_CHARTS_DATA,
} from "./mutations.type";

import {
  MODULE_PREFIX_NEWS,
  MODULE_PREFIX_SOCIAL,
  MODULE_PREFIX_USER,
  MODULE_PREFIX_HOME,
  MODULE_PREFIX_TOPICS_V2,
} from "@/store";

import {
  getTopicsArray,
  getInfluencesArray,
} from "@/services/events/topics.service";
import { isFeatureUnlocked } from "@/common/featureLock";
import { hasTwitterAccess } from "@/services/user/user.service";

let state = {
  keyword: null,
  searchDetails: null,
  type: null,
  bounds: null,
  loading: null,
  location: {
    place: null,
    refreshMap: false,
  },
  enabledItems: {
    news: null,
    social: null,
  },
  charts: {
    type: null,
    data: null,
  },
};

let TOPICS_ARRAY = null;
let INFLUENCES_ARRAY = null;

function init() {
  TOPICS_ARRAY = getTopicsArray();
  TOPICS_ARRAY.forEach((topic) => {
    const field = topic.parentIds ? "apiName" : "type";
    const type = topic[field];
    state.enabledItems[type] = null;
  });
  INFLUENCES_ARRAY = getInfluencesArray();
  INFLUENCES_ARRAY.forEach((topic) => {
    state.enabledItems[topic.type] = null;
  });
}

const STATE = state;

const GETTERS = {
  keyword: (state) => state.keyword,
  location: (state) => state.location,
  enabledItems: (state) => state.enabledItems,
  searchDetails: (state) => state.searchDetails,
  type: (state) => state.type,
  bounds: (state) => state.bounds,
  loading: (state) => state.loading,
  charts: (state) => state.charts,
};

const ACTIONS = {
  [GET_SEARCH_KEYWORD](context, data) {
    init();
    if (data === state.keyword) {
      //Skip applying this change if nothing has changed
      //(bonus it no longer wipes out mapped data if a search was never done)
      return;
    }

    let topicsAvailable = TOPICS_ARRAY;
    if (isFeatureUnlocked("influences")) {
      topicsAvailable = TOPICS_ARRAY.concat(INFLUENCES_ARRAY);
    }

    let topics = [];
    topicsAvailable.forEach((topic) => {
      const field = topic.parentIds ? "apiName" : "type";
      const type = topic[field];
      if (isFeatureUnlocked(type)) {
        if (
          topic.parentIds ||
          (!topic.parentIds && topic.subtopics.length === 0)
        ) {
          topics.push(topic);
        }
      }
    });

    let selectorPanel = context.rootState.home.selectorPanel;
    let keyword = null;
    let enabledItems = {};

    let preferences = lodashCloneDeep(context.rootState.user.preferences);
    preferences.media = preferences.media ? preferences.media : {};
    preferences.events = preferences.events ? preferences.events : {};
    preferences.topics = preferences.topics ? preferences.topics : {};
    preferences.liveSearch = preferences.liveSearch
      ? preferences.liveSearch
      : {};

    // NEWS
    enabledItems.news = null;
    preferences.media.news = preferences.media.news
      ? preferences.media.news
      : {};

    // SOCIAL
    if (hasTwitterAccess()) {
      enabledItems.social = null;
      preferences.media.social = preferences.media.social
        ? preferences.media.social
        : {};
    }

    // EVENTS
    topics.forEach((topic) => {
      const field = topic.parentIds ? "apiName" : "type";
      const type = topic[field];
      enabledItems[type] = null;
      preferences.topics[type] = preferences.topics[type]
        ? preferences.topics[type]
        : {};
    });

    // SET_SEARCH_ENABLED_ITEMS keep track of the user's button states
    // before searching so we can't set it back after search is done
    if (data) {
      // if brand new search then save the user's pref
      if (!context.rootState.search.keyword) {
        enabledItems.news = preferences.media.news.enabled;

        if (hasTwitterAccess()) {
          enabledItems.social = preferences.media.social.enabled;
        }

        topics.forEach((topic) => {
          const field = topic.parentIds ? "apiName" : "type";
          const type = topic[field];
          let enabled = false;
          if (
            topic.parentIds ||
            (!topic.parentIds && topic.subtopics.length === 0)
          ) {
            enabled = preferences.topics[type].enabled;
          }
          enabledItems[type] = enabled;
        });
      }

      keyword = data;

      preferences.media.news.enabled = true;
      selectorPanel.news = true;

      if (hasTwitterAccess()) {
        preferences.media.social.enabled = true;
        selectorPanel.social = true;
      }

      topics.forEach((topic) => {
        let field = "type";
        let topType;
        if (topic.parentIds && topic.parentIds[0]) {
          field = "apiName";
          topType = topic.parentIds[0];
        } else {
          topType = topic.type;
        }
        const type = topic[field];
        if (
          topic.parentIds ||
          (!topic.parentIds && topic.subtopics.length === 0)
        ) {
          preferences.topics[type].enabled = true;
          selectorPanel[topType] = true;
        }
      });
      context.commit(SET_SEARCH_ENABLED_ITEMS, enabledItems);
    } else {
      preferences.media.news.enabled =
        context.rootState.search.enabledItems.news;
      selectorPanel.news = context.rootState.search.enabledItems.news;

      if (hasTwitterAccess()) {
        preferences.media.social.enabled =
          context.rootState.search.enabledItems.social;
        selectorPanel.social = context.rootState.search.enabledItems.social;
      }

      topics.forEach((topic) => {
        let field = "type";
        let topType;
        if (topic.parentIds && topic.parentIds[0]) {
          field = "apiName";
          topType = topic.parentIds[0];
        } else {
          topType = topic.type;
        }
        const type = topic[field];
        enabledItems[type] = context.rootState.search.enabledItems[type];
        if (
          topic.parentIds ||
          (!topic.parentIds && topic.subtopics.length === 0)
        ) {
          preferences.topics[type].enabled =
            context.rootState.search.enabledItems[type];
          selectorPanel[topType] = context.rootState.search.enabledItems[type];
        }
      });
      context.commit(SET_SEARCH_ENABLED_ITEMS, enabledItems);
    }

    context.dispatch(MODULE_PREFIX_HOME + GET_SELECTOR_PANEL, selectorPanel, {
      root: true,
    });
    context.dispatch(MODULE_PREFIX_USER + SAVE_PREFERENCES, preferences, {
      root: true,
    });

    context.dispatch(MODULE_PREFIX_NEWS + GET_NEWS_REFRESH_MAP, true, {
      root: true,
    });

    if (hasTwitterAccess()) {
      context.dispatch(MODULE_PREFIX_SOCIAL + GET_SOCIAL_REFRESH_MAP, true, {
        root: true,
      });
    }

    const refresh = new Date().toISOString();
    topics.forEach((topic) => {
      const field = topic.parentIds ? "apiName" : "type";
      const type = topic[field];
      if (
        topic.parentIds ||
        (!topic.parentIds && topic.subtopics.length === 0)
      ) {
        const enabled = data ? true : enabledItems[type];
        context.dispatch(
          MODULE_PREFIX_TOPICS_V2 + GET_TOPICS_V2_MAP_TOPIC,
          {
            type: type,
            enabled: enabled,
            refresh: refresh,
          },
          { root: true }
        );
      }
    });

    context.dispatch(
      MODULE_PREFIX_TOPICS_V2 + GET_TOPICS_V2_REFRESH_MAP,
      refresh,
      { root: true }
    );

    context.commit(SET_SEARCH_KEYWORD, keyword);
  },
  [GET_SEARCH_LOCATION](context, data) {
    context.commit(SET_SEARCH_LOCATION, data);
  },
  [GET_SEARCH_LOCATION_REFRESH_MAP](context, data) {
    context.commit(SET_SEARCH_LOCATION_REFRESH_MAP, data);
  },
  [GET_SEARCH_ENABLED_ITEMS](context, data) {
    context.commit(SET_SEARCH_ENABLED_ITEMS, data);
  },
  [GET_SEARCH_DETAILS](context, data) {
    if (data === state.searchDetails) {
      return;
    }
    context.commit(SET_SEARCH_DETAILS, data);
  },
  [GET_SEARCH_TYPE](context, data) {
    context.commit(SET_SEARCH_TYPE, data);
  },
  [GET_SEARCH_BOUNDS](context, data) {
    context.commit(SET_SEARCH_TYPE, data);
  },
  [GET_SEARCH_LOADING](context, data) {
    context.commit(SET_SEARCH_LOADING, data);
  },
  [GET_CHARTS_DATA](context, data) {
    context.commit(SET_CHARTS_DATA, data);
  },
};

const MUTATIONS = {
  [SET_SEARCH_KEYWORD](state, data) {
    state.keyword = data;
  },
  [SET_SEARCH_LOCATION](state, data) {
    state.location.place = data;
  },
  [SET_SEARCH_LOCATION_REFRESH_MAP](state, data) {
    state.location.refreshMap = data;
  },
  [SET_SEARCH_ENABLED_ITEMS](state, data) {
    state.enabledItems = data;
  },
  [SET_SEARCH_DETAILS](state, data) {
    state.searchDetails = data;
  },
  [SET_SEARCH_TYPE](state, data) {
    state.type = data;
  },
  [SET_SEARCH_BOUNDS](state, data) {
    state.type = data;
  },
  [SET_SEARCH_LOADING](state, data) {
    state.loading = data;
  },
  [SET_CHARTS_DATA](state, data) {
    state.charts = data;
  },
};

export default {
  namespaced: true,
  state: STATE,
  actions: ACTIONS,
  mutations: MUTATIONS,
  getters: GETTERS,
};
